/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Czech
export default {
  'goal-actions.archive-goal.generic-error-title': 'Cíl nelze archivovat',
  'goal-actions.copy-goal.cancel': 'Zrušit',
  'goal-actions.copy-goal.close-modal': 'Zavřít modální okno',
  'goal-actions.copy-goal.error': 'Pojmenujte cíl, aby všichni věděli, o čem je.',
  'goal-actions.copy-goal.failed-description': 'Při klonování cíle došlo k chybě. Zkuste to znovu později.',
  'goal-actions.copy-goal.failed-description-forbidden': 'Ke kopírování tohoto cíle nemáte oprávnění.',
  'goal-actions.copy-goal.failed-title': 'Klonování tohoto cíle se nezdařilo.',
  'goal-actions.copy-goal.followers': 'Sledující',
  'goal-actions.copy-goal.goal-name': 'Název cíle',
  'goal-actions.copy-goal.include': 'Zahrnout',
  'goal-actions.copy-goal.links': 'Odkazy',
  'goal-actions.copy-goal.submit': 'Odeslat',
  'goal-actions.copy-goal.success-description': 'Cíl byl úspěšně klonován.',
  'goal-actions.copy-goal.success-link': 'Podívejte se na klonovaný cíl.',
  'goal-actions.copy-goal.success-title': 'Cíl {goalName} byl klonován.',
  'goal-actions.copy-goal.title': 'Kopírovat cíl',
  'goal-actions.follow-goal.follow-error-title': 'Sledování cíle se nepodařilo aktivovat',
  'goal-actions.follow-goal.unfollow-error-title': 'Sledování cíle se nepodařilo zrušit',
  'goal-actions.goal-actions.archive-error-title': 'Obnovení cíle se nezdařilo',
  'goal-actions.goal-actions.archive-goal': 'Archivovat cíl',
  'goal-actions.goal-actions.archive-restore-error-description': 'Změny cíle nelze uložit. Zkuste to znovu později.',
  'goal-actions.goal-actions.copy-goal': 'Kopírovat cíl',
  'goal-actions.goal-actions.copy-link': 'Kopírovat odkaz',
  'goal-actions.goal-actions.follow': 'Sledovat',
  'goal-actions.goal-actions.generic-error-description': 'Něco se pokazilo. Zkuste to znovu za pár minut.',
  'goal-actions.goal-actions.restore-goal': 'Obnovit cíl',
  'goal-actions.goal-actions.share': 'Sdílet',
  'goal-actions.goal-actions.show-more': 'Zobrazit více',
  'goal-actions.goal-actions.unfollow': 'Přestat sledovat',
  'goal-actions.goal-content.follow-confirmation-description':
    'První týden následujícího měsíce vám zašleme souhrn aktualizací ohledně všech cílů, které sledujete.',
  'goal-actions.goal-content.follow-confirmation-title': '🙌🏼 Nyní sledujete tento cíl!',
  'goal-actions.restore-goal.generic-error-title': 'Obnovení cíle se nezdařilo',
};
